import { useLazyMyInfoQuery, useRegisterMutation } from "app/apiSlice";
import { isAxiosError } from "axios";
import LoadingSpinner from "components/LoadingSpinner";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "services/authService";
import TokenService from "services/tokenService";
import { StorageUtils } from "utils/storageUtils";

const NaverCallback = () => {
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const savedState = sessionStorage.getItem("oauth_state");
  const isModal = StorageUtils.IsLoginModal.get();
  const [fetchMyInfo] = useLazyMyInfoQuery();
  const [register] = useRegisterMutation();

  useEffect(() => {
    if (!code || !state) {
      navigate("/login", { replace: true });
      return;
    }
    if (savedState && state !== savedState) {
      alert("잘못된 인증 요청입니다.");
      navigate("/login", { replace: true });
      return;
    }
    const handledKey = `oauth_naver_handled_${code}`;
    if (sessionStorage.getItem(handledKey) === "1") {
      return;
    }
    sessionStorage.setItem(handledKey, "1");
    sessionStorage.removeItem("oauth_state");

    const getToken = async () => {
      try {
        const response = await AuthService.naverLogin(code, state);
        if (response.status < 300) {
          TokenService.setAccessToken(response.data.accessToken);
          StorageUtils.RecentLoginMethod.set("NAVER");
          const myInfo = await fetchMyInfo().unwrap();

          if (myInfo.userStatus === "ACTIVE") {
            navigate(isModal ? "/search-results" : "/", { replace: true });
            return;
          }
          if (myInfo.userStatus === "PENDING") {
            navigate("/auth/additional-info", {
              state: {
                userInfo: {
                  firstName: myInfo.name || "",
                  phoneNumber: myInfo.phone || "",
                  email: myInfo.email || "",
                  providerId: myInfo.provider || "",
                },
                ssoName: "NAVER",
              },
              replace: true,
            });
            return;
          }
          navigate("/login", { replace: true });
        }
      } catch (error) {
        if (isAxiosError(error)) {
          const rawUserInfo = error.response?.data?.userInfo ?? {};
          const userInfo = {
            firstName: rawUserInfo.firstName ?? "",
            phoneNumber: rawUserInfo.phoneNumber ?? "",
            email: rawUserInfo.email ?? "",
            providerId: rawUserInfo.providerId ?? "",
          };

          if (!userInfo.providerId) {
            navigate("/login", { replace: true });
            return;
          }

          const form = new FormData();
          form.append("name", userInfo.firstName || "guest");
          form.append("email", userInfo.email);
          form.append("phone", userInfo.phoneNumber);
          form.append("ssoId", userInfo.providerId);
          form.append("ssoName", "NAVER");

          try {
            const signup = await register(form).unwrap();
            TokenService.setAccessToken(signup.accessToken);
            StorageUtils.RecentLoginMethod.set("NAVER");
            const myInfo = await fetchMyInfo().unwrap();
            navigate("/auth/additional-info", {
              state: {
                userInfo: {
                  firstName: myInfo.name || userInfo.firstName,
                  phoneNumber: myInfo.phone || userInfo.phoneNumber,
                  email: myInfo.email || userInfo.email,
                  providerId: myInfo.provider || userInfo.providerId,
                },
                ssoName: "NAVER",
              },
              replace: true,
            });
            return;
          } catch {
            alert("Social Login failed");
            navigate("/login", { replace: true });
            return;
          }
        } else {
          alert("Social Login failed");
          navigate("/login", { replace: true });
          return;
        }
      }
    };
    getToken();
  }, [code, state, savedState, fetchMyInfo, register, isModal, navigate]);

  return <LoadingSpinner />;
};

export default NaverCallback;
